<div class="cart-page">
  <div class="cart-header">
    <h1 class="cart-title">Shopping Cart</h1>
    @if (entries$ | async; as entries) {
      <div>
        <p class="cart-subtitle">{{entries?.length === 0 ? emptyCart : reviewItems}}</p>
      </div>
    }
  </div>
  @if (cart$ | async; as cart) {
    <div class="delivery-options">
      @if ({spinnerActive : commonService.showInlineSpinner$ | async}; as $) {
        @if ($.spinnerActive == 'deliveryPickup-loader') {
          <knbr-cwt-spinner class="cart-spinner-backdrop" [calssName]="'deliveryPickup-loader'"></knbr-cwt-spinner>
        }
      }
      <h2 class="delivery-options-title" [ngClass]="{ 'disabled': !cart || cart?.entries?.length === 0 }">Pickup and delivery options</h2>
      <p class="delivery-options-subtitle">Choose an option to change all items in your cart</p>
      <div class="container"  [ngClass]="{ 'disabled': !cart || cart?.entries?.length === 0 }">
        <div class="row">
          @for (mode of deliveryModeOptions; track mode; let i = $index) {
            <div class="col-6 delivery-buttons">
              <label class="delivery-option" [ngClass]="{'selected' : isSelectedOption(cart, mode)}">
                <input
                  type="radio"
                  name="deliveryMode"
                  [value]="mode?.code"
                  [checked]="isSelectedOption(cart, mode)"
                  (change)="deliveryModeSelection(mode?.code, i)"
                  [disabled]="!cart"
                  >
                  <div class="delivery-option-icon">{{ mode?.code === 'pickUp' ? '🏪' : '🚛' }}</div>
                  <div class="delivery-option-title">{{ mode?.code === 'pickUp' ? 'Pick Up' : 'Delivery' }}</div>
                </label>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>